<template>
    <div style="height: 500px;border: 1px solid #d6d6da;background-color: #FFFFFF;border-radius: 5px;">
        <el-scrollbar style="height: 100%;" ref="refScrollbar">
            <div class="div-agreement" style="">
                <p style="text-align: center;font-size: 16px;text-indent: 0;">教师认证协议</p>
                <p>欢迎您使用南京恒点信息技术有限公司(以下简称”恒点”)所提供的恒点MOOL服务，恒点MOOL
                    是一个实时互动教育平台，为教师、学生或独立的知识传授者、分享者提供完善的在线教育工具和平台能力，为求知者提供丰富的知识内容和一起学习的教学平台。
                    为使用恒点MOOL提供教师端服务（以下简称：本服务），您应当阅读并遵守《恒点MOOL服务合作协议》（以下简称“本协议”）的相关规则。
                    请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议、规则。
                    除非您已阅读并接受本协议及相关协议、规则等所有条款，否则，您无权使用恒点提供的本服务。您使用恒点提供的本服务，即视为您已阅读并同意上述协议、规则等的约束。
                    您有违反本协议的任何行为时，恒点有权依照违反情况，随时单方限制、中止或终止向您提供本服务，并有权追究您的相关责任。</p>

                <p>一、术语含义</p>
                <p>如无特别说明，下列术语在本协议中的含义为：</p>
                <p>1.1
                    教师：指经有效注册、申请后，将其享有相应权利的各种知识接入恒点MOOL并向用户提供各种免费或收费类的在线互动教学、直播服务以实现与用户进行在线交流与学习目的的个人、法人或其他组织，本协议中简称为“您”或“教师”。
                </p>
                <p>1.2 知识内容：指由教师开发，或教师经权利人授权，通
                    过恒点MOOL向相关用户提供各种免费或收费类的互动教学、直播形式的交流与学习服务，包括但不限于VR-MOOC、在线实验室、直播、微专业、VR智慧教室、考试系统、VR-编辑器等现有的各种教学服务及今后可能出现的各种教学服务。
                </p>
                <p>1.3 恒点：指南京恒点信息技术有限公司，或其拥有、控制、运营的恒点MOOL服务平台（www.hdmooc.com等）。</p>
                <p>
                    恒点信息：指由恒点所控制、运营的恒点MOOL软件服务（包括hdvrar.com以及恒点APP），以下简称为“恒点MOOL”、“MOOL平台”。恒点通过恒点MOOL向您提供的服务包括但不限于提供互动教学平台、费用支付服务等服务，具体以恒点提供和您选择的服务为准。
                </p>
                <p>恒点、教师均同意和理解：</p>
                <p>（1）恒点MOOL是一个中立的平台服务提供者，仅向教师提供信息存储空间、在线传播等中立的网络服务或相关中立的技术支持服务，以供教师在中立的平台上自主发布、推广其知识内容等；</p>
                <p>（2）教师的知识内容由教师自主开发、发布并独立承担全部责任；</p>
                <p>
                    （3）因教师分享内容及服务产生的任何纠纷、责任等，以及分享违反相关法律法规或本协议约定引发的任何后果，均由教师独立承担责任、赔偿损失，与恒点MOOL无关。如侵害到恒点MOOL、以及其关联公司或他人权益的，教师须自行承担全部责任和赔偿一切损失。
                </p>
                <p>1.4
                    恒点MOOL运营数据：是指用户或教师在使用恒点MOOL相关服务中产生的相关运营数据，包括但不限于用户或教师操作行为形成的数据、各类教学数据等，“恒点MOOL数据”、“平台数据”。“恒点MOOL数据”的所有权及其他相关权利均属于恒点，且是恒点的商业秘密，未经恒点书面授权您不得使用。但依法属于用户、教师享有相关权利的数据或分享内容等除外
                </p>
                <p>1.5 机构：是指在教师开设的恒点MOOL分享中，具体提供交流与学习服务的学校或其他组织。</p>
                <p>1.6
                    教师责任：教师是指在教师开设的恒点MOOL分享中，具体提供交流与学习服务的个人，或学校教师。应对其发布内容承担一切与法律相关的责任，若机构邀请教师并以机构自己名义发布教师的知识内容的，由机构承担全部责任。
                </p>
                <p>二、教师的权利和义务</p>
                <p>2.1 教师认证</p>
                <p>如无特别说明，下列术语在本协议中的含义为：</p>
                <p>2.1.1 您应当通过登录恒点MOOL网站、软件或恒点指定的其他途径，注册帐号（下简称：恒点帐号）并通过教师认证后成为教师，恒点帐号一经注册成功，该帐号不可转让、不可赠与、不可继承等。
                </p>
                <p>2.1.2 您不得违反本协议约定将您的恒点帐号用于其他目的。否则，恒点有权随时单方限制、中止或终止向您提供本服务，且未经恒点同意您不得再次使用本服务。</p>
                <p>2.1.3
                    您注册并经认证过的恒点教师帐号，是您登录及使用本服务的凭证。您应当做好恒点帐号、密码，以及进入和管理本服务中的各类产品与服务的口令、密码等的保密措施。因您保密措施不当或您的其他行为，致使上述口令、密码等丢失或泄漏所引起的一切损失和后果，均由您自行承担。
                </p>
                <p>2.1.4 恒点MOOL帐号管理员有权以您账号的名义进行操作。</p>
                <p>2.1.5
                    您保证：您注册本服务的帐号及您添加的帐号管理员使用的恒点帐号的使用权均是合法获取的。前述全部恒点帐号在本服务中进行的包括但不限于以下事项：注册本服务帐号、提交相应资质材料、确认和同意相关、选择具体服务类别以及进行费用结算等事项，均是您自行或您授权他人进行的行为，对您均有约束力。同时，您承担以前述全部恒点帐号为标识进行的全部行为的法律责任。
                </p>
                <p>2.1.6 您保证不得通过任何手段恶意注册恒点帐号，包括但不限于以牟利、炒作、套现等为目的的注册和认证，亦不得盗用其他用户信息进行认证。
                    如您违反上述规定，则恒点有权直接采取一切必要的措施，包括但不限于删除您发布的内容、暂停或查封用户帐号，取消因违规所获利益，以及通过诉讼形式追究您法律责任等。</p>
                <p>2.1.7 若您发现有他人冒用或盗用您的教师帐号及密码、或任何其他未经您合法授权的情形时，
                    您应立即以有效方式通知恒点并提供恒点所需的相关材料（包括但不限于提供您的身份信息和相关身份资料、相关事实情况及您的要求等）。恒点收到您的有效请求并核实身份后，
                    会根据不同情况采取相应措施。若您提供的信息不完全，导致恒点无法核实您的身份或恒点无法判断您的需求等，而导致恒点无法进行及时处理，
                    给您带来的损失，您应自行承担。同时，恒点对您的请求采取措施需要合理期限，对于您通知恒点以及恒点根据您的有效通知采取措施之前， 由于他人行为给您造成的损失，恒点不承担任何责任。</p>
            </div>
        </el-scrollbar>
        <el-checkbox label="我同意管理员查看我的实名信息" size="small" v-model="isAgree" style="margin-top: 10px;">
        </el-checkbox>
        <div style="margin-top: 20px;text-align: center;">
            <el-button type="primary" size="mini" style="width: 100px;" @click="preStep()" plain="plain" v-if="preUrl">
                上一步
            </el-button>
            <el-button type="primary" size="mini" style="width: 100px;" @click="nextStep()" v-if="isCanNext">下一步
            </el-button>
            <el-button :disabled="true" type="info" size="mini" style="width: 100px;" v-if="!isCanNext">下一步
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SubTeacherAgreement',
    props: ['pre', 'next'],
    created () {
        this.preUrl = this.pre
        this.nextUrl = this.next
    },
    mounted () {
        let that = this
        this.$nextTick(function () {
            that.judgeTop()
        })
    },
    data () {
        return {
            isAgree: false,
            preUrl: '',
            nextUrl: '',
            isCanNext: false
        }
    },
    methods: {
        judgeTop () {
            let that = this
            let scrollTop = that.$refs.refScrollbar.wrap.scrollTop
            if (scrollTop < 780) {
                setTimeout(function () {
                    that.judgeTop()
                }, 500)
            } else {
                this.isCanNext = true
            }
        },
        preStep () {
            this.$router.push({
                path: this.preUrl
            })
        },
        nextStep () {
            if (!this.isAgree) {
                this.$message.error('请勾选同意')
                return
            }
            this.$router.push({
                path: this.nextUrl
            })
        }
    }
}
</script>

<style>
.div-agreement {
    padding: 15px;
    font-size: 14px;
}

.div-agreement p {
    text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/public/sub/SubTeacherAgreement.vue